import ActionTypes from './ActionTypes';
import reducer from './reducer';
import routes from './routes';

export default {
  routes,
  reducers: {
    'zap-templates': reducer,
  },
  actionTypes: ActionTypes,
};
